export default "__VITE_ASSET__CFfxWejg__"